import React from 'react';
import styled from 'styled-components';
import { useMutation } from '@apollo/react-hooks';
import Button from '../Button';
import colors from '../../styles/colors';
import { CANCEL_SUBSCRIPTION } from '../../graphql/queries';

const Container = styled.div`
  padding: 20px 15px;
`;

const Text = styled.div`
  font-size: 1.4rem;
  color: ${colors.grey3};
`;

const Spacer = styled.div`
  height: 15px;
`;

export default function CancelAccountModal({ close }) {
  const [cancelSubscription, { loading }] = useMutation(CANCEL_SUBSCRIPTION, {
    onCompleted(data) {
      localStorage.clear();
      window.location.href = '/login';
    },
    onError(error) {
      console.error(error);
    },
  });

  return (
    <Container>
      <Text>
        Are you sure you want to cancel your Check This Out account?
      </Text>
      <Spacer />
      <Text>
        You will immediately be charged your outstanding balance, your customers’ outstanding discounts will be voided, and you will be locked out of your account until you enter a credit card again.
      </Text>
      <Button
        margin="30px 0px 0px 0px"
        text="No don't cancel"
        width="100%"
        onClick={() => (loading ? null : close())}
      />
      <Button
        margin="20px 0px 0px 0px"
        text="Yes, cancel my account"
        width="100%"
        loading={loading}
        onClick={() => (loading ? null : cancelSubscription())}
      />
    </Container>
  );
}
